import React from 'react';
import {Link} from 'react-router-dom';
import logo from 'image/logo/logo_01.png';

const Page404 = ({location}) => {
  return (
    <div className="Page404">
      <div className="wrap-title">
        <div className="contents">
          <h1>4</h1>
          <img src={logo} alt="logo"/>
          <h1>4</h1>
        </div>
      </div>
      <div className="wrap-text">
        <p>Page Not Found</p>
        <Link to = "/" className="btn-link">동구밭 홈</Link>
      </div>
    </div>
  );
}

export default Page404;